//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = (value) =>
  value != null && value != undefined ? value : "N/A";

export default {
  name: "StocksTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: function () { },
  data: () => ({
    separator: "horizontal",
    columns: [
      {
        name: "date",
        required: false,
        label: "Data",
        align: "left",
        field: (row) => row.date,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "store-code",
        required: false,
        label: "Código Loja",
        align: "left",
        field: (row) => (row.store ? row.store.code : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "store-description",
        required: false,
        label: "Descrição Loja",
        align: "left",
        field: (row) => (row.store ? row.store.name : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "ean",
        required: false,
        label: "EAN",
        align: "left",
        field: (row) => (row.product ? row.product.ean : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      // {
      //   name: "internal-code-dws",
      //   required: false,
      //   label: "Código Interno Produto",
      //   align: "left",
      //   field: (row) => row.InternalCode,
      //   format: DEFAULT_FORMAT,
      //   sortable: false,
      // },
      {
        name: "internal-description-dws",
        required: false,
        label: "Descrição Interna Produto",
        align: "left",
        field: (row) => (row.product ? row.product.name : "N/A"),
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "internal-code-rtl-dws",
        required: false,
        label: "Código Interno RTL",
        align: "left",
        field: (row) =>
          row.product.product_retailer_info
            ? row.product.product_retailer_info.sku
            : "N/A",
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "internal-description-rtl-dws",
        required: false,
        label: "Descrição Interna RTL",
        align: "left",
        field: (row) =>
          row.product.product_retailer_info
            ? row.product.product_retailer_info.name
            : "N/A",
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "abc-class",
        required: false,
        label: "Classe ABC",
        align: "left",
        field: (row) => row.abc_class,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "status",
        required: false,
        label: "Status",
        align: "left",
        field: (row) => row.cardex_status,
        format: DEFAULT_FORMAT,
        sortable: false,
        icon: {
          conditional: true,
          false: {
            name: "mdi-close-circle-outline",
            label: "Inactivo",
            color: "red-4",
          },
          true: {
            name: "mdi-check-circle-outline",
            label: "Activo",
            color: "green-4",
          },
        },
      },
      {
        name: "last-sale-date",
        required: false,
        label: "Data Última Venda",
        align: "left",
        field: (row) => row.last_sale_date,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "days-without-sales",
        required: false,
        label: "DSV desde última venda",
        align: "left",
        field: (row) => row.dwsa_last_sale,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "stocks-on-hand",
        required: false,
        label: "Stocks on hand",
        align: "left",
        field: (row) => row.stock_on_hand,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "ps-stock",
        required: false,
        label: "Stock de Prateleira",
        align: "left",
        field: (row) => row.ps_stock,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "stocks-in-transit",
        required: false,
        label: "Stocks Trânsito",
        align: "left",
        field: (row) => row.stock_in_transit,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "stocks-waiting",
        required: false,
        label: "Stocks Espera",
        align: "left",
        field: (row) => row.expected_stock,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "stocks-orders",
        required: false,
        label: "Stocks Encomenda",
        align: "left",
        field: (row) => row.ordered_stock,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "avg-sales",
        required: false,
        label: "Média de Vendas",
        align: "left",
        field: (row) => row.avg_sales,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "coverage-days",
        required: false,
        label: "Dias Cobertura",
        align: "left",
        field: (row) => row.coverage_days,
        format: DEFAULT_FORMAT,
        sortable: false,
      },

      {
        name: "dwsa-aggregator",
        required: false,
        label: "DSV Agregador",
        align: "left",
        field: (row) => row.dwsa_agregg,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "dwst-aggregator",
        required: false,
        label: "DSS Agregador",
        align: "left",
        field: (row) => row.dwst_agregg,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
      {
        name: "vendor",
        required: false,
        label: "Vendedor",
        align: "left",
        field: (row) => row.vendor,
        format: DEFAULT_FORMAT,
        sortable: false,
      },
    ],
  }),
  methods: {},
};
